import Navbar from '../components/Navbar';
import MOTD from '../components/control_widgets/MOTD';
import Waypoint from '../components/control_widgets/Waypoint';
import Project from '../components/control_widgets/Project';
import Phases from '../components/control_widgets/Phases';
import Action from '../components/control_widgets/Action';
import {  useAppDispatch, useAppSelector } from "../hooks";
import OpenButton from '../components/popup_components/OpenButton';
import AddActionPopup from '../components/Forms/AddAction';
import SelectDataviewProject from '../components/Forms/SelectDataviewProject';
import AvailableActions from '../components/Forms/AvailableActions';
import PageContainer from '../components/containers/PageContainer';
import ContentBlock from '../components/containers/ContentBlock';
import { useEffect } from 'react';




export default function Control() {
  const current_project = useAppSelector(state => state.Projects.current_project);
  const dispatch = useAppDispatch()
  useEffect(()=>{
    dispatch({ type: 'ssestream/connect', payload: "goBack" })
  },[])
  return (
    <>
      <Navbar />
      <PageContainer
        title="Control"
        buttons={
          <>
            <OpenButton
              text="Available Actions"
              styleClasses="font-bold text-xs"
              newContent={<AvailableActions />}
            />
            
            <OpenButton 
            text='Add Action' 
            styleClasses='font-bold text-xs' 
            newContent={<AddActionPopup />} />

          </>
          
        }
      >
      <div className="grid control-grid w-full gap-4">
        <div className="left">
          <ContentBlock title="Set message">
            <MOTD />
          </ContentBlock>
          <ContentBlock title="Set waypoint">
            <Waypoint />
          </ContentBlock>
          <ContentBlock title="Project">
            <Project />
          </ContentBlock>
            {current_project !== undefined || process.env.REACT_APP_DEBUG === "true" ?
            <ContentBlock title="Phases">
              <Phases></Phases>
            </ContentBlock>
              :
              <div></div>
            }
        </div>
        <div className="right">
        {current_project !== undefined || process.env.REACT_APP_DEBUG === "true" ?
            <Action />
            :
            <div></div>
          }
        </div>
      </div>
    </PageContainer >
    </>
  );
}